export class Sort {
  order: 'ASC' | 'DESC';
  field: string;

  constructor(field: string, order: 'ASC' | 'DESC') {
    this.field = field;
    this.order = order;
  }
}
